import { render, staticRenderFns } from "./CRUDModelGroup.vue?vue&type=template&id=68e497d1"
import script from "./CRUDModelGroup.vue?vue&type=script&lang=js"
export * from "./CRUDModelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports